export const state = {
  besoin: undefined,
  besoins: [],
  pagination: { size: 10 },
};